import { render, staticRenderFns } from "./CowDashboard.vue?vue&type=template&id=095f0ab8&scoped=true&"
import script from "./CowDashboard.vue?vue&type=script&lang=js&"
export * from "./CowDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095f0ab8",
  null
  
)

export default component.exports